import './font-faces.css';
import { importSVGs } from '@powdr/utils';

import { config } from './config';
import { fontTheme } from './fonts';
import { overrides } from './overrides';
import {
  altTheme,
  defaultTheme,
  StaticTheme,
} from './themes';

const theme = {
  svgs: { ...importSVGs(require.context('../assets/svgs', true, /\.svg$/)) },
  defaultTheme,
  StaticTheme,
  altTheme,
  config,
  ...fontTheme,
  overrides: { ...overrides },
};

export default theme;
